import React, { useEffect, useState } from "react";
import api, { fmtINR } from "../lib/api";
import { Page } from "../components/Primitives";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

export default function Reports() {
  const [rev, setRev] = useState(null);
  const [tat, setTat] = useState(null);
  const [inv, setInv] = useState(null);
  const [tech, setTech] = useState([]);

  useEffect(() => {
    api.get("/reports/revenue").then(({ data }) => setRev(data));
    api.get("/reports/tat").then(({ data }) => setTat(data));
    api.get("/reports/inventory").then(({ data }) => setInv(data));
    api.get("/reports/technician").then(({ data }) => setTech(data));
  }, []);

  return (
    <Page number="10" title="Reports" subtitle="Revenue, turnaround time, inventory value, technician productivity.">
      <div className="grid lg:grid-cols-2 gap-6">
        <section className="kk-card p-5">
          <div className="kk-overline">Monthly Revenue</div>
          <div className="font-display text-xl uppercase mt-1">Revenue Trend</div>
          {rev && rev.by_month.length > 0 ? (
            <div className="h-64 mt-4" style={{ width: "100%", minHeight: 256 }}>
              <ResponsiveContainer width="100%" height="100%">
                <LineChart data={rev.by_month}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#E5E5E0" />
                  <XAxis dataKey="month" fontSize={11} />
                  <YAxis fontSize={11} />
                  <Tooltip formatter={(v) => fmtINR(v)} />
                  <Line type="monotone" dataKey="revenue" stroke="#0A0A0A" strokeWidth={2} dot={{ fill: "#CCFF00", r: 5 }} />
                </LineChart>
              </ResponsiveContainer>
            </div>
          ) : <div className="text-sm text-[var(--kk-muted)] mt-3">No paid invoices yet.</div>}
        </section>

        <section className="kk-card p-5">
          <div className="kk-overline">Service Turnaround</div>
          <div className="font-display text-xl uppercase mt-1">Average TAT</div>
          {tat ? (
            <div>
              <div className="font-display text-5xl mt-3">{tat.avg_tat_hours} hr</div>
              <div className="text-xs text-[var(--kk-muted)] mt-1">Based on {tat.count} delivered job cards</div>
              {tat.items.length > 0 && (
                <ul className="mt-4 space-y-1 text-xs max-h-48 overflow-y-auto">
                  {tat.items.map((i) => (
                    <li key={i.code} className="flex justify-between border-b border-[var(--kk-border)] py-1">
                      <span className="font-mono">{i.code}</span><span>{i.tat_hours} hr</span>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ) : "—"}
        </section>

        <section className="kk-card p-5">
          <div className="kk-overline">Stores</div>
          <div className="font-display text-xl uppercase mt-1">Inventory Value</div>
          {inv ? (
            <div className="grid grid-cols-3 gap-4 mt-4">
              <div><div className="kk-overline">Items</div><div className="font-display text-2xl">{inv.total_items}</div></div>
              <div><div className="kk-overline">Value</div><div className="font-display text-2xl">{fmtINR(inv.total_value)}</div></div>
              <div><div className="kk-overline">Low Stock</div><div className="font-display text-2xl">{inv.low_stock_count}</div></div>
            </div>
          ) : "—"}
        </section>

        <section className="kk-card p-5">
          <div className="kk-overline">People</div>
          <div className="font-display text-xl uppercase mt-1">Technician Productivity</div>
          {tech.length > 0 ? (
            <div className="h-64 mt-4" style={{ width: "100%", minHeight: 256 }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={tech}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#E5E5E0" />
                  <XAxis dataKey="name" fontSize={11} />
                  <YAxis fontSize={11} />
                  <Tooltip />
                  <Bar dataKey="jobs_completed" fill="#0A0A0A" />
                  <Bar dataKey="hours_logged" fill="#CCFF00" />
                </BarChart>
              </ResponsiveContainer>
            </div>
          ) : <div className="text-sm text-[var(--kk-muted)] mt-3">No technician data.</div>}
        </section>
      </div>
    </Page>
  );
}
